import axios from "@/http"
export default {
  name:"showClub",
  listShowClub(param){
    return axios({
      method:"GET",
      url:"/api/v1/extra/showclub/articles",
      params:param
    })
  },
  listShowClubTags(param){
    return axios({
      method:"GET",
      url:"/api/v1/extra/showclub/tags",
      param
    })
  },
  deleteShowClub(id){
    return axios({
      url: '/api/v1/extra/showclub/articles/' + id,
      method: 'delete'
    })
  },
  createShowClubAttachment(data){
    return axios({
      url: '/api/v1/extra/showclub/attachments',
      method: 'POST',
      data:data
    })
  },
  updateShowClub(data) {
    return axios({
      url: '/api/v1/extra/showclub/articles/' + data.id,
      method: 'put',
      params: data.where?{where: data.where}: undefined,
      data
    })
  },
  deleteShowClubAttachment(id) {
    return axios({
      url: '/api/v1/extra/showclub/attachments/' + id,
      method: 'delete'
    })
  },
  createShowClub(param){
    return axios({
      url: '/api/v1/extra/showclub/articles',
      method: 'POST',
      data:param
    })
  },
  getShowClub(id){
    return axios({
      url: '/api/v1/extra/showclub/articles/'+id,
      method: 'GET',
      params: { id,preload: true }
    })
  },
  deleteTagsRelation(param){
    return axios({
      url: '/api/v1/extra/showclub/relation/articletags',
      method: 'DELETE',
      params: param
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/axj-extracurricular/axj-extra-show-club-api.js